<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <h1>BetIABitCrypto</h1>
        <p>Trading Automatizado em Polymarket</p>
      </div>

      <form @submit.prevent="handleLogin" class="login-form">
        <div v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>

        <div class="form-group">
          <label for="username">Usuario</label>
          <input
            id="username"
            v-model="form.username"
            type="text"
            placeholder="Seu usuario"
            required
            @keyup.enter="handleLogin"
          />
        </div>

        <div class="form-group">
          <label for="password">Senha</label>
          <input
            id="password"
            v-model="form.password"
            type="password"
            placeholder="Sua senha"
            required
            @keyup.enter="handleLogin"
          />
        </div>

        <button type="submit" class="btn-login" :disabled="loading">
          <span v-if="loading">Autenticando...</span>
          <span v-else>Entrar</span>
        </button>
      </form>

    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useAuthStore } from '../stores/authStore';

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();

const form = ref({
  username: '',
  password: ''
});

const loading = ref(false);
const errorMessage = ref('');

onMounted(() => {
  authStore.logout();
});

const handleLogin = async () => {
  errorMessage.value = '';
  loading.value = true;
  form.value.username = String(form.value.username || '').trim();
  form.value.password = String(form.value.password || '').trim();

  try {
    const success = await authStore.login(form.value.username, form.value.password);

    if (success) {
      const redirectTo = route.query.redirect || '/';
      router.push(redirectTo);
    } else {
      errorMessage.value = authStore.error || 'Falha na autenticacao';
    }
  } catch (error) {
    const responseData = error.response?.data || null;
    if (responseData) {
      console.error('[LOGIN] response body:', responseData);
    }
    if (responseData?.received_username !== undefined) {
      errorMessage.value = `${responseData.error} | usuario recebido: ${responseData.received_username || '(vazio)'}`;
    } else {
      errorMessage.value = responseData?.error || error.message || 'Erro ao conectar';
    }
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.login-box {
  background: white;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  padding: 40px;
  max-width: 400px;
  width: 100%;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h1 {
  margin: 0 0 10px;
  font-size: 32px;
  color: #333;
}

.login-header p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.form-group input {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.btn-login {
  padding: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  margin-top: 10px;
}

.btn-login:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error-message {
  background: #fee;
  color: #c33;
  padding: 12px;
  border-radius: 6px;
  font-size: 14px;
  border-left: 4px solid #c33;
}

.login-info {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  font-size: 12px;
  color: #666;
}

.login-info p {
  margin: 5px 0;
}

.login-info code {
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
}

.warning {
  color: #d97706 !important;
  font-weight: 600 !important;
}

@media (max-width: 480px) {
  .login-box {
    padding: 30px 20px;
  }

  .login-header h1 {
    font-size: 24px;
  }
}
</style>
